import { MarketOrderWrapper } from '../entryTacticModules/MarketOrderModule/wrapper/MarketOrderWrapper';
import { BreakPriceWrapper } from '../exitTacticModules/BreakPriceModule/wrapper/BreakPriceWrapper';
import BounceEmaWrapper from '../setupModules/BounceEmaModule/wrapper/BounceEmaWrapper';
import { CandleTrailWrapper } from '../exitTacticModules/CandleTrailModule/wrapper/CandleTrailWrapper';
import { BounceWrapper } from '../setupModules/bounceModule/wrapper/BounceWrapper';
import { GrabCentsWrapper } from '../exitTacticModules/GrabCentsModule/wrapper/GrabCentsWrapper';
import { GreenToRedCandlesWrapper } from '../exitTacticModules/GreenToRedCandlesModule/wrapper/GreenToRedCandlesWrapper';
import { GreenToRedPositionsWrapper } from '../exitTacticModules/GreenToRedPositionsModule/wrapper/GreenToRedPositionsWrapper';
import { LossLimitWrapper } from '../exitTacticModules/LossLimitModule/wrapper/LossLimitWrapper';
import { PositionPriceTrailWrapper } from '../exitTacticModules/PositionPriceTrailModule/wrapper/PositionPriceTrailWrapper';
import { PreserveProfitWrapper } from '../exitTacticModules/PreserveProfitModule/wrapper/PreserveProfitWrapper';
import { RatchetBracketWrapper } from '../exitTacticModules/RatchetBracketModule/wrapper/RatchetBracketWrapper';
import { UnderlyingPriceTrailWrapper } from '../exitTacticModules/UnderlyingPriceTrailModule/wrapper/UnderlyingPriceTrailWrapper';
import BreakCandleTypeWrapper from '../setupModules/BreakCandleTypeModule/wrapper/BreakCandleTypeWrapper';
import BreakEmaWrapper from '../setupModules/BreakEmaModule/wrapper/BreakEmaWrapper';
import BreakWrapper from '../setupModules/breakModule/wrapper/BreakWrapper';
import { LimitOrderWrapper } from '../entryTacticModules/LimitOrderModule/wrapper/LimitOrderWrapper';
import { CandleBreakWrapper } from '../entryTacticModules/CandleBreakModule/wrapper/CandleBreakWrapper';
import { AddToWinnerWrapper } from '../positionTacticModules/AddToWinnerModule/wrapper/AddToWinnerWrapper';
import { ScalingInWrapper } from '../positionTacticModules/ScalingInModule/wrapper/ScalingInWrapper';
import { CandleMagnitudeWrapper } from '../exitTacticModules/CandleMagnitudeModule/wrapper/CandleMagnitudeWrapper';
import { CandleTriggerWrapper } from '../setupModules/CandleTriggerModule/wrapper/CandleTriggerWrapper';
import { ConvictionCandleWrapper } from '../setupModules/ConvictionCandleModule/wrapper/ConvictionCandleWrapper';
import { OrbWrapper } from '../setupModules/OrbModule/wrapper/OrbWrapper';
import { CandlePatternWrapper } from '../setupModules/candlePatternModule/wrapper/CandlePatternWrapper';
import { FlagWrapper } from '../setupModules/FlagModule/wrapper/FlagWrapper';
import { PriceIntersectsFirstCandleWrapper } from '../SetupFilterModules/PriceIntersectsFirstCandleModule/wrapper/PriceIntersectsFirstCandleWrapper';
import { EmaIntersectsFirstCandleWrapper } from '../SetupFilterModules/EmaIntersectsFirstCandleModule/wrapper/EmaIntersectsFirstCandleWrapper';
import { TimeOfDayModuleWrapper } from '../SetupFilterModules/TimeOfDayModule/wrapper/TimeOfDayWrapper';
import { FtfcWrapper } from '../SetupFilterModules/FTFCModule/wrapper/FtfcWrapper';
import { AtrTrailWrapper } from '../exitTacticModules/AtrTrailModule/AtrTrailWrapper';
import { MfeRetracementWrapper } from '../exitTacticModules/MfeRetracementModule/MfeRetracementWrapper';
import { UnderlyingPriceExitWrapper } from '../exitTacticModules/UnderlyingPriceExitModule/UnderlyingPriceExitWrapper';
import { PositionBreakPriceWrapper } from '../exitTacticModules/PostitionBreakPriceModule/PositionBreakPriceWrapper';

export const tacticNameToWrapperMap = {
  //SETUPS
  BOUNCE: BounceWrapper,
  BREAK: BreakWrapper,
  AD_HOC: null, //nothing to display
  CONVICTION_CANDLE: ConvictionCandleWrapper,
  BOUNCE_EMA: BounceEmaWrapper,
  BREAK_EMA: BreakEmaWrapper,
  CANDLE_PATTERN: CandlePatternWrapper,
  CANDLE_TRIGGER: CandleTriggerWrapper,
  FLAG: FlagWrapper,
  ORB: OrbWrapper,
  BREAK_CANDLE_TYPE: BreakCandleTypeWrapper,

  //SETUP FILTERS
  PRICE_INTERSECTS_FIRST_CANDLE: PriceIntersectsFirstCandleWrapper,
  EMA_INTERSECTS_FIRST_CANDLE: EmaIntersectsFirstCandleWrapper,
  TIME_OF_DAY: TimeOfDayModuleWrapper,
  FTFC_FILTER: FtfcWrapper,
  //ENTRIES
  MARKET_ORDER: MarketOrderWrapper,
  LIMIT_ORDER: LimitOrderWrapper,
  CANDLE_BREAK: CandleBreakWrapper,

  //POSITION
  ADD_TO_WINNER: AddToWinnerWrapper,
  SCALING_IN: ScalingInWrapper,

  //EXITS,
  BREAK_PRICE: BreakPriceWrapper,
  CANDLE_TRAIL: CandleTrailWrapper,
  GRAB_CENTS: GrabCentsWrapper,
  GREEN_TO_RED_CANDLES: GreenToRedCandlesWrapper,
  GREEN_TO_RED_POSITIONS: GreenToRedPositionsWrapper,
  LOSS_LIMIT: LossLimitWrapper,
  POSITION_PRICE_TRAIL: PositionPriceTrailWrapper,
  PRESERVE_PROFIT: PreserveProfitWrapper,
  RATCHET_BRACKET: RatchetBracketWrapper,
  UNDERLYING_PRICE_TRAIL: UnderlyingPriceTrailWrapper,
  CANDLE_MAGNITUDE: CandleMagnitudeWrapper,
  ATR_TRAIL: AtrTrailWrapper,
  MFE_RETRACEMENT: MfeRetracementWrapper,
  UNDERLYING_PRICE_EXIT: UnderlyingPriceExitWrapper,
  POSITION_BREAK_PRICE: PositionBreakPriceWrapper,
};
